var map = {
	"./A-Normal.svg": "47ee8",
	"./CombinedShape.svg": "a5a4",
	"./CombinedShape2.svg": "722f",
	"./LRC.svg": "6073",
	"./Mac-1.svg": "ec96",
	"./Mac.svg": "e11c",
	"./Open.svg": "86dc",
	"./Pause.svg": "739d",
	"./Play.svg": "953e",
	"./Refresh.svg": "0ea9",
	"./Rise.svg": "7d2b",
	"./Round-Solid.svg": "3539",
	"./Solid-1.svg": "4ea1",
	"./Solid-2.svg": "cfe0",
	"./Upload.svg": "3938",
	"./Win-1.svg": "c5fa",
	"./Win.svg": "440f",
	"./accompany.svg": "2a62",
	"./anzhuo-1.svg": "2258",
	"./anzhuo.svg": "08ba",
	"./chexiao.svg": "1150",
	"./closed.svg": "11f8",
	"./cover.svg": "a186",
	"./cuti.svg": "3cc9",
	"./down-2.svg": "765b",
	"./down.svg": "d681",
	"./duiqifangshi.svg": "c96c",
	"./erweimadenglu.svg": "a34f",
	"./guanbi.svg": "c8cf",
	"./hefahuachuban.svg": "d112",
	"./hefahuachuban1.svg": "9d1d",
	"./iOS-1.svg": "8e3d",
	"./iOS.svg": "dca5",
	"./ic_add_circle_outline.svg": "f1c1",
	"./ic_arrow_back.svg": "1175",
	"./ic_chevron_left.svg": "6bda",
	"./ic_chevron_right.svg": "eb61",
	"./ic_crop_free.svg": "fe85",
	"./ic_event_note.svg": "cce1",
	"./ic_info.svg": "cefc",
	"./ic_notifications.svg": "e45f",
	"./ic_refresh.svg": "09af",
	"./ic_remove_circle_outline.svg": "6783",
	"./jixushangchuan.svg": "612a",
	"./karaoke.svg": "e4d1",
	"./leyousuozhi.svg": "72d1",
	"./leyousuozhi1.svg": "5e07",
	"./line.svg": "4b7d",
	"./lyric.svg": "0603",
	"./mics.svg": "3e4c",
	"./music-player-4.svg": "db09",
	"./music.svg": "bac6",
	"./mv.svg": "a5f0",
	"./quanqiufabu.svg": "309d",
	"./quanqiufabu1.svg": "d934",
	"./short.svg": "6449",
	"./symphony.svg": "ae82",
	"./tianjia.svg": "1ceb",
	"./trash.svg": "ce30",
	"./weizhi.svg": "3870",
	"./xiahuaxian.svg": "fd7a",
	"./xiangmufuhao.svg": "f1d5",
	"./xieti.svg": "c449",
	"./xiugai.svg": "97b5",
	"./yidong.svg": "45c5",
	"./yingui-you.svg": "6963",
	"./yingui-zuo.svg": "2493",
	"./yonghumingdenglu.svg": "7f72",
	"./zhonghuaxian.svg": "7cdd",
	"./zhongzuo.svg": "c96a",
	"./zhuanji.svg": "4e87",
	"./zidongpaiban.svg": "f284",
	"./zitiyanse.svg": "a488",
	"./zizhushizuopinguanli.svg": "aa6b",
	"./zizhushizuopinguanli1.svg": "e322"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";